<template>
  <a-input-group compact>
    <a-select v-model="queryParam.search_condition">
      <a-select-option value="1">微信昵称</a-select-option>
      <a-select-option value="2">会员ID</a-select-option>
      <a-select-option value="4">微信ID</a-select-option>
    </a-select>
    <a-auto-complete
      placeholder="请输入关键字"
      @change="handleChange"
      optionLabelProp="value"
      v-model="value"
    >
      <template slot="dataSource">
        <a-select-option :key="'loading'" v-if="loading">
          <a-spin size="small"/>
        </a-select-option>
        <template v-else v-for="(item) in dataSource">
          <a-select-option :key="item.uid" :title="item.uid" :value="item.uid+''">UID：{{item.uid}}，微信昵称：{{item.nickname}}</a-select-option>
        </template>
      </template>
    </a-auto-complete>
  </a-input-group>
</template>

<script>
import FansApi from '@/api/fans'
import debounce from 'lodash/debounce'
export default {
  components: {},
  props: {
    robotid: {
      type: Number
    },
    uid: {
      type: String,
      required: false
    }
  },
  model: {
    prop: 'uid',
    event: 'returnBack'
  },
  watch: {
    value(newVal) {
      this.$emit('change', newVal)
      this.$emit('returnBack', newVal)
    }
  },
  data() {
    this.handleChange = debounce(this.handleChange, 500);
    return {
      loading: false,
      dataSource: [],
      value: null,
      // 查询参数
      queryParam: {
        search_condition: '2'
      },
    }
  },
  created() {
  },
  methods: {
    handleChange(value){
      this.loading = true
      // console.log('this.robotid',this.robotid)
      FansApi.getFansList(Object.assign(this.queryParam,{
        sub_id: this.robotid,
        pageSize: 10,
        keywords: value
      })).then(res=>{
        this.dataSource = res.data
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-input-group{
  display: inline-flex !important;
  .ant-select-enabled{
    width: 100px;
  }
  .ant-select-auto-complete{
    flex: 1;
  }
}
</style>
